import { gql } from 'glimmer-apollo';

export const ESPORTS_TEAM_QUERY = gql`
  query ($slug: String) {
    team(slug: $slug) {
      name
      country
      bioBlurb
      establishedDate
      logo {
        url(width: 200, height: 200, fit: cover, format: webp)
      }
      players {
        gamertag
        irlName
        role
        slug
        photo {
          url(width: 220, fit: cover, format: webp)
        }
        socialLinks {
          accessibilityDescription
          platform
          url
        }
      }
      tournaments {
        name
        logo {
          url(width: 64, height: 64, fit: cover, format: webp)
        }
        slug
      }
    }
  }
`;
